import classNames from 'classnames';
import * as React from 'react';
import Course from './Course';
import Staff from './Staff';
import SwitchCourseStaff from './SwitchCourseStaff';

import css from './index.module.scss';
import { MerchantBookingStaffApi } from '../../../../../../interfaces/merchants/bookings/staff';
import { MerchantBookingCourse } from '../../../../../../interfaces/merchants/bookings/courses';
import { useUserMe } from 'src/hooks/api/me';
import { useRouter } from 'next/router';
import {
  CourseSchemeResource,
  EventSchemeResource,
} from 'src/interfaces/reservation_flow';

export enum SwitchType {
  Course = 'course',
  Staff = 'staff',
}

interface Props {
  nickname: string;
  resourceId: string;
  courses: MerchantBookingCourse[];
  staff: MerchantBookingStaffApi[];
  resource?: EventSchemeResource | CourseSchemeResource;
}

const Appointment: React.FC<Props> = ({
  nickname,
  resourceId,
  courses,
  staff,
  resource,
}) => {
  const router = useRouter();
  const classes = classNames(css.Appointment);
  const bookingPath = `/${nickname}/${resourceId}/book`;

  const [switchType, setSwitchType] = React.useState(SwitchType.Course);
  const { user } = useUserMe();

  return (
    <div className={classes}>
      {staff.length > 0 && (
        <SwitchCourseStaff selected={switchType} onClick={setSwitchType} />
      )}
      <div className={css.Appointment__Content}>
        {switchType === SwitchType.Course &&
          courses.length > 0 &&
          courses.map((c) => {
            const query = new URLSearchParams();
            if (router.query.selected_date) {
              query.set('date', router.query.selected_date as string);
            }
            query.set('courseCanonicalId', c.canonical_id.toString());

            return (
              <Course
                key={c.canonical_id}
                course={c}
                href={`${bookingPath}/course_type?${query.toString()}`}
                resource={resource}
                user={user}
              />
            );
          })}
        {switchType === SwitchType.Staff &&
          staff.length > 0 &&
          staff.map((s) => {
            const query = new URLSearchParams();
            if (router.query.selected_date) {
              query.set('date', router.query.selected_date as string);
            }
            query.set('staffCanonicalId', s.canonical_id.toString());

            return (
              <Staff
                key={s.canonical_id}
                staff={s}
                href={`${bookingPath}/course_type?${query.toString()}`}
                resource={resource}
                user={user}
              />
            );
          })}
      </div>
    </div>
  );
};

export default Appointment;
